import * as ol from 'openlayers/dist/ol-debug';
import * as table from './LBCore.table';

// Interfaces
import {
	Route
} from './LBCore.interface';

export namespace LB {

	export class RouteSegment {
		private routeId: string;
		/* This startMP and endMP is same as the value in control panel.
		   It represents: the range of route seg that shows on map.
		   Not represents: the range of routelog data nor eventdata. */
		private startMP: number;
		private endMP: number;
		/*-----------------------------------------------------------*/
		private fromTime = new Date(); // ????
		private toTime = new Date();
		private dataBufferPct = 1; // 150% // data buffer percentage
		private dataRange = [];
		// --TODO: figure out routeLog vs routeLogData in LBV / LBE
		private routeLogMeta;
		private routeLogData;
		// --------------------------------------------------------
		public routeGeom; // geojson
		private routeMpRange: number[]; // should be updated if routeParts is changed
		private routeParts: any[]; // should be updated if route is changed
		// Keep this for future use.
		// LBE isn't useing this for now since all the log data will be returned everytime.
		private routeLogRange = [];
		// this.routeLogBuffer = 10;
		// Setvice calls
		private getGeomService;
		constructor(routeId, servicesConfig, startMP?, endMP?) {
			this.getGeomService = servicesConfig.getGeomService;
			this.setNewRoute(routeId);
		}

		getRouteId() {
			return this.routeId;
		}
		getStartMp() {
			return this.startMP;
		}
		setStartMP(mp) {
			this.startMP = mp;
		}
		getEndMp() {
			return this.endMP;
		}
		setEndMP(mp) {
			this.endMP = mp;
		}
		getRouteParts() {
			return this.routeParts;
		}
		setRoutePart(parts) {
			this.routeParts = parts;
		}
		getRouteMpRange() {
			return this.routeMpRange;
		}
		setRouteMpRange(range) {
			this.routeMpRange = range;
		}
		getRoutelogData() {
			return this.routeLogData;
		}
		setRoutelogData(data) {
			this.routeLogData = data;
		}
		// Set routeParts from routeList by Id
		getRoutePartsFromRouteList(list: Route[], id) {
			let routeParts = null;
			const route = list.find((r) => r.id === id);
			if (route) {
				routeParts = route.parts;
			}
			return routeParts;
		}
		getRouteRangeByRouteParts() {
			const routeRange = [];
			if (this.routeParts) {
				const startMpList = [];
				const endMpList = [];
				this.routeParts.forEach((part) => {
					startMpList.push(part.start);
					endMpList.push(part.end);
				});
				routeRange[0] = Utility.getArrayRange(startMpList)[0];
				routeRange[1] = Utility.getArrayRange(endMpList)[1];
				return routeRange;
			}
		}
		setRouteGeom(geom, type?, lrsdm?) {
			switch (type) {
				case 'WKT':
					const wktFormat = new ol.format.WKT();
					const geometry: any = wktFormat.readGeometry(geom);
					this.routeGeom = {
						geometry: {
							type: geometry.getType(),
							coordinates: geometry.getCoordinates(),
						},
						lrsdm: lrsdm || 3
					};
				break;
				default:
					this.routeGeom = geom;
			}
		}
		setNewRoute(routeId, setGeom?: boolean, successCallback?, errorCallback?) {
			return new Promise((resolve, reject) => {
				if (!routeId && routeId !== 0) {
					// console.log('Fail to setNewRoute. RouteId cannot be ' + routeId);
					console.log('clear routeSegment info');
					// Clear route info
					this.routeId = null;
					this.startMP = null;
					this.endMP = null;
					this.fromTime = new Date();
					this.toTime = new Date();
					this.dataRange = [];
					this.routeLogData = null;
					this.routeGeom = null;
					this.routeMpRange = null;
					this.routeParts = null;
					this.routeLogRange = [];
					resolve();
					return;
				}
				// Set routeId.
				this.routeId = routeId;
				// Set route geometry.
				if (setGeom !== false) {
					this.fetchRouteGeomById(successCallback, errorCallback);
				}
				// ALSO SHOULD DO IN CODE:
				// Set routeParts
			});
		}
		// Get route geometry By routeId
		// Use the function outside passed by getGeomService
		// TODO: replace setRouteSegGeom
		fetchRouteGeomById(successCallback?, errorCallback?) {
			return this.getGeomService(this.routeId, (rsp) => {
				// this.setRouteGeom(rsp);
				if (successCallback) {
					successCallback(rsp);
				}
			}, errorCallback);
		}
		updateRouteLog(routeID, startMP, endMP) {
			// switch(app) {
			// 	case 'LBE':
			// 		var defer = $.Deferred();
			// 		var self = this;
			// 		if (globalCustomerID !== null && routeID !== null && startMP !== null && endMP !== null) {
			// 			$.ajax({
			// 				method: 'GET',
			// 				url: newUrl + 'lbcore/getRouteLogData',
			// 				data: {
			// 					customerId: globalCustomerID,
			// 					routeId: routeID,
			// 					startMilePost: startMP,
			// 					endMilePost: endMP
			// 				},
			// 				context: this
			// 			}).then(function(rsp) {
			// 				rsp = handleAjaxResponse(rsp);
			// 				if (!rsp.error) {
			// 					this.routeID = routeID;
			// 					this.routeLogRange = [startMP, endMP];
			// 					var dataArray = rsp.content;
			// 					this.routeLogData = dataArray;
			// 					$.ajax({
			// 						method: 'GET',
			// 						url: newUrl + 'lbcore/getRouteLogMetaData',
			// 						data: {
			// 							customerId: globalCustomerID
			// 						},
			// 						context: this
			// 					}).then(function(rsp) {
			// 						rsp = handleAjaxResponse(rsp);
			// 						if (!rsp.error) {
			// 							this.routeLogMeta = rsp.content;
			// 							defer.resolve(this);
			// 						}
			// 					}).fail(function() {

			// 					});
			// 				}
			// 			}).fail(function() {

			// 			});
			// 		}
			// 		else {
			// 			defer.resolve(this);
			// 		}
			// 		return defer.promise();
			// 	case 'LBV':
			// 		var defer = $.Deferred();
			// 		if (globalCustomerID !== null && routeID !== null && startMP !== null && endMP !== null && (this.routeID !== routeID || this.startMP !== startMP || this.endMP !== endMP)) {
			// 			$.ajax({
			// 				method: 'POST',
			// 				url: lbsUrlRoot + 'GetRouteLogData',
			// 				context: this,
			// 				data: {
			// 					customerID: globalCustomerID,
			// 					routeID: routeID,
			// 					startMP: startMP,
			// 					endMP: endMP
			// 				}
			// 			}).then(function(rsp) {

			// 				this.routeID = routeID;
			// 				this.startMP = startMP;
			// 				this.endMP = endMP;
			// 				console.log(this);
			// 				// debugger;
			// 				//parse data using jsonh
			// 				var array = JSON.parse(rsp.data_str);
			// 				//---using JSONH to unpack the array
			// 				var dataArray = JSONH.unpack(array);
			// 				this.routeLogData = dataArray;
			// 				// debugger;
			// 				$.ajax({
			// 					method: 'POST',
			// 					url: lbsUrlRoot + 'GetRouteLog',
			// 					context: this,
			// 					data: {
			// 						customerID: globalCustomerID,
			// 						username: 'lit',
			// 						mainTabID: 'SLD',
			// 						action: 'GetRouteLog',
			// 						routeID: routeID,
			// 						startMP: startMP,
			// 						endMP: endMP
			// 					}
			// 				}).then(function(rsp) {
			// 					this.routeLog = rsp;

			// 					defer.resolve(this);
			// 				}).fail(function() {

			// 				});
			// 			}).fail(function() {

			// 			});
			// 		}
			// 		return defer.promise();
			// }
		}
		// TODO: getAllRouteLog is not used in LBE. Might be merged with updateRouetLog when doing LBV core.
		getAllRouteLog(routeID, startMP, endMP) {// get all routelog data based on routeID
			// var defer = $.Deferred();
			// if (globalCustomerID !== null && routeID !== null && startMP !== null && endMP !== null) {
			// 	$.ajax({
			// 		method: 'GET',
			// 		url: newUrl + 'lbcore/getRouteLogData',
			// 		data: {
			// 			customerId: globalCustomerID,
			// 			routeId: routeID,
			// 			startMilePost: startMP,
			// 			endMilePost: endMP
			// 		},
			// 		context: this
			// 	}).then(function(rsp) {
			// 		var content = handleAjaxResponse(rsp).content;
			// 		this.routeID = routeID;
			// 		this.startMP = startMP;
			// 		this.endMP = endMP;
			// 		//---using JSONH to unpack the array
			// 		var dataArray = JSONH.unpack(content);
			// 		this.routeLogData = dataArray;
			// 		// debugger;
			// 		$.ajax({
			// 			method: 'GET',
			// 			url: newUrl + 'lbcore/getRouteLogMetaData',
			// 			data: {
			// 				customerId: globalCustomerID
			// 			},
			// 			context: this
			// 			// data: {
			// 			// 	customerID: globalCustomerID,
			// 			// 	username: 'lit',
			// 			// 	mainTabID: 'SLD',
			// 			// 	action: 'GetRouteLog',
			// 			// 	routeID: routeID,
			// 			// 	startMP: startMP,
			// 			// 	endMP: endMP
			// 			// }
			// 		}).then(function(rsp) {
			// 			this.routeLogMeta = rsp;

			// 			defer.resolve(this);
			// 		}).fail(function() {

			// 		});
			// 	}).fail(function() {

			// 	});
			// }
			// return defer.promise();
		}
		updateRouteGeom(routeID) {
			// return $.ajax({
			// 	method: 'GET',
			// 	url: newUrl + 'lbcore/getRouteGeometry',
			// 	data: {
			// 		customerId: globalCustomerID,
			// 		routeId: routeID
			// 	},
			// 	context: this
			// }).then(function(rsp) {
			// 	rsp = handleAjaxResponse(rsp);
			// 	if (!rsp.error) {
			// 		this.routeID = routeID;
			// 		this.routeGeom = rsp.content;
			// 	}
			// 	return this;
			// }).fail(function(er) {
			// });
		}
		// Get buffer for route measure by event measure
		// If multiple events, fromM and toM should be the from / to of all events
		getBufferByEventMeas(fromM, toM) {
			if (fromM === toM) {
				return 3; // hard code
			} else {
				return this.dataBufferPct * (toM - fromM);
			}
		}
		getBufferedMeasByEventMeas(eventFromM, eventToM) {
			const buffer = this.getBufferByEventMeas(eventFromM, eventToM);
			const startMp = eventFromM - buffer >= this.routeMpRange[0] ? eventFromM - buffer : this.routeMpRange[0];
			const endMp = eventToM + buffer <= this.routeMpRange[1] ? eventToM + buffer : this.routeMpRange[1];
			return [startMp, endMp];
		}
		withinBufferOrNot(currentDataRange) {
			if (typeof(currentDataRange[0]) === 'number' && currentDataRange[0] <= this.startMP && currentDataRange[1] >= this.endMP ) {
				return true;
			} else {
				return false;
			}
		}
	}
	export class Utility {
		static getArrayRange(arr) {
			let min = arr[0];
			let max = arr[0];
			const range = [];
			for (let i = 0; i < arr.length; i++) {
				if (min > arr[i]) {
					min = arr[i];
				}
				if (max < arr[i]) {
					max = arr[i];
				}
			}
			range.push(min);
			range.push(max);
			return range;
		}
		static arrayToObjectByFirstProp(data: object[]): object {
			const convertedObj: any = {};
			let prop: string;
			for (let i = 0; i < data.length; i++) {
				prop = Object.keys(data[i])[0];
				convertedObj[prop] = data[i][prop];
			}
			return convertedObj;
		}
	}
	export class TableUtility {
		static smartDisplay(inputs: any[], header: string, type: any) { // TODO: type
			return table.smartDisplay(inputs, header, type);
		}

		// Get max string length from columns
		static getColumnsMaxStringLen(data: any[]) {
			const maxStrLen: any = {};
			for (const name in data[0]) {
				if (data[0][name]) {
					maxStrLen[name] = data[0][name].toString().length;
				} else {
					maxStrLen[name] = 0;
				}
			}
			// Use the first 100 rows to calculate.
			const count = data.length > 100 ? 100 : data.length;
			for (let i = 1; i < count; i++) {
				for (const name in data[i]) {
					if (data[i][name]) {
						maxStrLen[name] = data[i][name].toString().length > maxStrLen[name] ? data[i][name].toString().length : maxStrLen[name];
					}
				}
			}
			return maxStrLen;
		}
	}

}



// WEBPACK FOOTER //
// ./src/assets/TS/LBCore.ts